import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Homepage from './Homepage'; // OLD VERSION - kept locally for ROI calculator reference
import HomepageV2 from './HomepageV2'; // Homepage NICHT lazy — sofortiger Bedarf

// Lazy Loading für alle anderen Seiten
const CheckoutPage = lazy(() => import('./pages/Checkout/CheckoutPage'));
const CheckoutSuccessPage = lazy(() => import('./pages/Checkout/CheckoutSuccessPage'));
const AnalysePage = lazy(() => import('./pages/Analyse/AnalysePage'));
const SichtbarkeitPage = lazy(() => import('./pages/Sichtbarkeit/SichtbarkeitPage'));
const TerminPage = lazy(() => import('./pages/Termin/TerminPage'));
const TerminPageAT = lazy(() => import('./pages/Termin/TerminPageAT'));
const DankePage = lazy(() => import('./pages/Termin/DankePage'));
const Kontakt = lazy(() => import('./pages/Kontakt'));
const Werbevereinbarung = lazy(() => import('./pages/Marketingvereinbarung'));
const Erfolgsgeschichten = lazy(() => import('./pages/Erfolgsgeschichten'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Loading Fallback — minimalistisch, kein Flackern
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: 'Inter, -apple-system, sans-serif',
    color: '#1e3a8a',
    fontSize: '16px'
  }}>
    Wird geladen...
  </div>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomepageV2 />} />
          {/* Statische Seiten (Impressum, Datenschutz, AGB, Über uns) werden jetzt
              direkt von S3/CloudFront als HTML ausgeliefert — keine React-Routes nötig */}
          <Route path="/werbevereinbarung/" element={<Werbevereinbarung />} />
          <Route path="/werbevereinbarung" element={<Navigate to="/werbevereinbarung/" replace />} />
          <Route path="/kontakt/" element={<Kontakt />} />
          <Route path="/kontakt" element={<Navigate to="/kontakt/" replace />} />
          <Route path="/erfolgsgeschichten/" element={<Erfolgsgeschichten />} />
          <Route path="/erfolgsgeschichten" element={<Navigate to="/erfolgsgeschichten/" replace />} />
          <Route path="/termin/" element={<TerminPage />} />
          <Route path="/termin" element={<Navigate to="/termin/" replace />} />
          <Route path="/termin/danke" element={<DankePage />} />

          {/* Checkout Routes */}
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout-success" element={<CheckoutSuccessPage />} />

          {/* Öffentliche Analyse-Seite für smartEMAIL */}
          <Route path="/analyse/:leadId" element={<AnalysePage />} />

          {/* Öffentliche Sichtbarkeit-Seite (Low Volume Angle) */}
          <Route path="/sichtbarkeit/:leadId" element={<SichtbarkeitPage />} />

          {/* Österreich-Termin-Seite */}
          <Route path="/de-at/termin" element={<TerminPageAT />} />

          {/* Vanity-URLs → Checkout Redirects */}
          <Route path="/starter" element={<Navigate to="/checkout?package=starter" replace />} />
          <Route path="/pro" element={<Navigate to="/checkout?package=professional" replace />} />
          <Route path="/starten" element={<Navigate to="/checkout?package=professional" replace />} />
          <Route path="/staren" element={<Navigate to="/checkout?package=professional" replace />} />

          {/* 404 – muss als letztes stehen */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
